<!--
 * @Author: chengleilei
 * @Date: 2026-02-09 10:52:13
 * @Description: 变更记录tab
-->
<template>
    <card :bordered="true">
        <TablePage :list="tableConfig" @onPageChange="onPageChange" @onPageSizeChange="onPageSizeChange" />
    </card>
</template>

<script>
import TablePage from '@/components/tablePage';
import { apiChangeLog } from '@/api/store';
import { changeRecordColumns } from '../const';

export default {
    components: { TablePage },
    data() {
        return {
            id: this.$route.query.id || '',
            tableConfig: {
                current: 1,
                size: 10,
                total: 0,
                columns: changeRecordColumns,
                data: [],
                loading: true,
            },
        };
    },
    mounted() {
        this.getData();
    },

    methods: {
        async getData() {
            try {
                this.tableConfig.loading = true;
                const params = {
                    storeId: this.id,
                    current: this.tableConfig.current,
                    size: this.tableConfig.size,
                };
                const res = await apiChangeLog(params);
                this.tableConfig.total = Number(res.total);
                this.tableConfig.data = res.records || [];
            } finally {
                this.tableConfig.loading = false;
            }
        },
        onPageChange(val) {
            this.tableConfig.current = val;
            this.getData();
        },
        onPageSizeChange(val) {
            this.tableConfig.current = 1;
            this.tableConfig.size = val;
            this.getData();
        },
    },
};
</script>
